var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.wrapperTag,_vm._g({tag:"component",staticClass:"button__wrapper text-body-sm",class:_vm.dynamicClass,attrs:{"to":_vm.to,"disabled":_vm.isButtonDisabled}},_vm.$listeners),[(_vm.loading)?_c('button-spinner'):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }